import type {
  ChallengesState,
  ChallengesAction
} from '@/redux/challenges/types';

import type { Dispatch } from 'redux';
import type { Challenge } from '@/services/api/types';

export enum Actions {
  SetChallengeData = 'SetChallengeData',
  SetChallengeDataFail = 'SetChallengeDataFail',

  SetChallengesData = 'SetChallengesData',
  SetChallengesDataFail = 'SetChallengesDataFail'
}

export const setChallengeData =
  (challenge: Challenge) => (dispatch: Dispatch<ChallengesAction>) => {
    try {
      dispatch({
        type: Actions.SetChallengeData,
        data: { challenges: [challenge] }
      });
    } catch (error) {
      dispatch({ type: Actions.SetChallengeDataFail, error });
    }
  };

export const setChallengesData =
  (data: ChallengesState) => (dispatch: Dispatch<ChallengesAction>) => {
    try {
      dispatch({ type: Actions.SetChallengesData, data });
    } catch (error) {
      dispatch({ type: Actions.SetChallengesDataFail, error });
    }
  };
